import "./CreateApp.scss";
import { NavLink, useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { registerNewUserAPI, createNewAppAPI } from "../api/ClientApi";
import { useDispatch } from "react-redux";
import { handleLogoutRedux } from "../../redux/actions/userAction";
const CreateApp = (props) => {
  const [appId, setAppId] = useState("");
  const [appName, setAppName] = useState("");
  const [bundleId, setBundleId] = useState("");
  const [iconUrl, setIconUrl] = useState("");
  const [appUrl, setAppUrl] = useState("");
  const [firebaseCredential, setFirebaseCredential] = useState("");
  const [firebaseCredentialSandbox, setFirebaseCredentialSandbox] = useState("");

  const [os, setOS] = useState("ios");
  const containsWhitespace = (str) => /\s/.test(str);

  const defaultObjectCheck = {
    isValidAppID: true,
    isValidAppName: true,
    isValidBundleId: true,
    isValidIconUrl: true,
    isValidOS: true,
    isValidAppUrl: true,
  };
  const [objectCheckInput, setObjectCheckInput] = useState(defaultObjectCheck);
  const history = useHistory();
  const dispatch = useDispatch();
  const handleRegister = () => {
    let invalid = invalidInputs();
    if (invalid) {
      createNewAppAPI({
        appId,
        appName,
        bundleId,
        iconUrl,
        os,
        appUrl,
        firebaseCredential,
        firebaseCredentialSandbox,
      }).then((response) => {
        let { errorCode, message } = response;
        if (errorCode === 0) {
          toast.success(message);
          history.push("/admin");
        } else if (errorCode === 401) {
          toast.error(message);
          dispatch(handleLogoutRedux());
        } else {
          toast.error(message);
        }
      });
    }
  };

  const invalidInputs = () => {
    setObjectCheckInput(defaultObjectCheck);
    if (!appId) {
      toast.error("App id is not empty!");
      setObjectCheckInput({ ...defaultObjectCheck, isValidAppID: false });
      return false;
    }
    if (!appName) {
      toast.error("App name is not empty!");
      setObjectCheckInput({ ...defaultObjectCheck, isValidAppName: false });
      return false;
    }

    if (!bundleId) {
      toast.error("Bundle id is not empty!");
      setObjectCheckInput({
        ...defaultObjectCheck,
        isValidBundleId: false,
      });

      return false;
    }
    if (!os) {
      toast.error("OS is not empty!");
      setObjectCheckInput({ ...defaultObjectCheck, isValidOS: false });
      return false;
    }
    if (containsWhitespace(appId)) {
      toast.error("App id is not contain whitespace!");
      setObjectCheckInput({ ...defaultObjectCheck, isValidAppID: false });
      return false;
    }
    return true;
  };

  return (
    <div className="page-container">
      <div className="auth-card auth-card--wide">
        <h1 className="page-title mb-1">Create New App</h1>
        <p className="page-subtitle mb-0">Đăng ký app mới để quản lý và gửi push notification.</p>

        <div className="form-section-title">Thông tin app</div>
        <div className="mb-3">
          <label className="form-label">App ID</label>
          <input
            className={
              objectCheckInput.isValidAppID
                ? "form-control"
                : "form-control is-invalid"
            }
            type="text"
            placeholder="com.example.app"
            value={appId}
            onChange={(event) => setAppId(event.target.value)}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">App Name</label>
          <input
            className={
              objectCheckInput.isValidAppName
                ? "form-control"
                : "form-control is-invalid"
            }
            type="text"
            placeholder="Tên hiển thị của app"
            value={appName}
            onChange={(event) => setAppName(event.target.value)}
          />
        </div>
        <div className="row">
          <div className="col-md-8 mb-3">
            <label className="form-label">Bundle ID</label>
            <input
              className={
                objectCheckInput.isValidBundleId
                  ? "form-control"
                  : "form-control is-invalid"
              }
              type="text"
              placeholder="com.example.app"
              value={bundleId}
              onChange={(event) => setBundleId(event.target.value)}
            />
          </div>
          <div className="col-md-4 mb-3">
            <label className="form-label">OS</label>
            <select
              className="form-select"
              value={os}
              onChange={(event) => {
                setOS(event.target.value);
              }}
            >
              <option value={"ios"}>iOS</option>
              <option value={"android"}>Android</option>
            </select>
          </div>
        </div>
        <div className="mb-3">
          <label className="form-label">Icon URL</label>
          <input
            className={
              objectCheckInput.isValidIconUrl
                ? "form-control"
                : "form-control is-invalid"
            }
            type="text"
            placeholder="https://... (tuỳ chọn)"
            value={iconUrl}
            onChange={(event) => setIconUrl(event.target.value)}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">App URL</label>
          <input
            className={
              objectCheckInput.isValidAppUrl
                ? "form-control"
                : "form-control is-invalid"
            }
            type="text"
            placeholder="https://... (tuỳ chọn)"
            value={appUrl}
            onChange={(event) => setAppUrl(event.target.value)}
          />
        </div>

        <div className="form-section-title">Firebase credential (tuỳ chọn)</div>
        <div className="mb-3">
          <label className="form-label">Firebase Service Account JSON (Production)</label>
          <textarea
            className="form-control"
            placeholder='{"type": "service_account", ...}'
            rows={5}
            value={firebaseCredential}
            onChange={(event) => setFirebaseCredential(event.target.value)}
          />
          <div className="form-text">Project Firebase thật — dùng khi gửi push cho user thật.</div>
        </div>
        <div className="mb-4">
          <label className="form-label">Firebase Service Account JSON (Sandbox)</label>
          <textarea
            className="form-control"
            placeholder='{"type": "service_account", ...}'
            rows={5}
            value={firebaseCredentialSandbox}
            onChange={(event) => setFirebaseCredentialSandbox(event.target.value)}
          />
          <div className="form-text">
            Project Firebase riêng cho test/nội bộ (tuỳ chọn) — chọn "Sandbox" khi gửi push để
            dùng project này thay vì production.
          </div>
        </div>

        <div className="d-flex gap-2">
          <button className="btn btn-primary flex-fill" onClick={() => handleRegister()}>
            Create App
          </button>
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={() => history.push("/admin")}
          >
            Huỷ
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateApp;
